// @flow

import saveEstimate from '../../../Services/saveEstimate';

export default () => async (dispatch: Function) => {
  
  await dispatch(saveEstimate());
  
}